import React from "react";

interface PagingLinkProps {
	page: number;
	selectedPage: number;
	onPageSelected: (page: number) => void;
	navBtn?: boolean;
	children?: React.ReactNode;
}

export function PagingLink({
	page,
	selectedPage,
	onPageSelected,
	navBtn,
	children,
}: PagingLinkProps) {
	const handleClick = (page: number) => {
		window.scrollTo({ top: 0, left: 0, behavior: "instant" });
		onPageSelected(page);
	};

	if (page === selectedPage) {
		return <span aria-current="true">{children}</span>;
	} else if (navBtn) {
		return (
			<button
				type="button"
				className="btn--nav"
				onClick={() => handleClick(page)}
			>
				{children}
			</button>
		);
	} else {
		return (
			<button type="button" onClick={() => handleClick(page)}>
				{children}
			</button>
		);
	}
}
